export default "__VITE_ASSET__BqRJ5UV6__"